export const GenericNetworkErrorMsg =
	"We could not connect to the network. Please check your connection and try again.";
